// @ts-nocheck
(() => {
  const COMPONENT_SELECTOR = '[data-spx-scroll-to-banner]';
  const FORM_CARD_SELECTOR = '.spx-home-banner-slide__form-card';
  const BANNER_SELECTOR = '.spx-swiper-home-banner';
  const HIDDEN_CLASS = 'spx-header-cta--hidden';

  const buttons = Array.from(document.querySelectorAll(COMPONENT_SELECTOR));
  if (buttons.length === 0) return;

  const formCards = Array.from(document.querySelectorAll(FORM_CARD_SELECTOR));
  const banner = document.querySelector(BANNER_SELECTOR);

  // 优先级：
  //   1. 有订阅表单卡片 → 以表单为基准监听（响应更灵敏，避免太晚显示）
  //   2. 没表单但有 banner → 回退监听 banner（保守旧行为）
  //   3. 都没有 → 按钮无处可滚，直接隐藏
  const targets = formCards.length > 0 ? formCards : banner ? [banner] : [];

  if (targets.length === 0) {
    buttons.forEach((b) => {
      b.hidden = true;
    });
    return;
  }

  // 点击 → 平滑滚到订阅表单卡片（更精确的「回到订阅」目标），
  // 没有表单时回滚到 banner 顶部。
  const scrollTarget = formCards[0] || banner;
  buttons.forEach((btn) => {
    if (btn.dataset.spxBound) return;
    btn.dataset.spxBound = 'true';
    btn.addEventListener('click', () => {
      scrollTarget.scrollIntoView({ behavior: 'smooth', block: 'start' });
    });
  });

  /**
   * 用 IntersectionObserver 控制按钮可见性：
   *   - 订阅表单卡片在视口内（含被 header 盖住的顶部）→ 隐藏，避免和表单同时出现；
   *   - 表单卡片完全离开 header 下方 → 显示，作为「滚回 banner 订阅」的快捷入口。
   *
   * 多个表单时：任一可见就隐藏，全部不可见才显示。
   *
   * rootMargin 顶部减去 --header-height，把 sticky header 的高度从判定区域里剔除，
   * 否则表单被 header 盖住时仍会被算作"在视口内"导致按钮提前隐藏。
   */
  // --header-height 由主题的 header 组件写在 :root（documentElement）上。
  // 先查 documentElement，再查 body 兜底，读不到就用 0（rootMargin 失效但不报错）。
  const headerHeight = (() => {
    const root = getComputedStyle(document.documentElement).getPropertyValue('--header-height');
    if (root.trim()) return parseFloat(root) || 0;
    const body = getComputedStyle(document.body).getPropertyValue('--header-height');
    return parseFloat(body) || 0;
  })();

  const setVisible = (visible) => {
    buttons.forEach((btn) => {
      btn.classList.toggle(HIDDEN_CLASS, !visible);
    });
  };

  // 维护每个目标的当前可见状态，entries 仅含变化项，需要累积。
  const visibilityMap = new Map();
  targets.forEach((t) => visibilityMap.set(t, false));

  const recompute = () => {
    const anyVisible = Array.from(visibilityMap.values()).some(Boolean);
    setVisible(!anyVisible);
  };

  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        visibilityMap.set(entry.target, entry.isIntersecting);
      });
      recompute();
    },
    {
      rootMargin: `-${headerHeight}px 0px 0px 0px`,
      threshold: 0,
    }
  );

  targets.forEach((t) => observer.observe(t));
})();